import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useMediaQuery, Typography, useTheme } from '@mui/material';

import {
  StyledCareDocumentContainer,
  StyledCareDocumentBodyContainer,
  StyledCareDocumentHeaderContainer,
} from './PatoloCareDocument.styled';
import { imgLinks } from '../../shared';
import { DownloadLink } from '../ui';

const docLink = '/docs/patolo_FDS.pdf';

const PatoloCareDocument = () => {
  const theme = useTheme();
  const intl = useIntl();
  const isDesktop = useMediaQuery(theme.breakpoints.up('desktop'));
  const isLgScreen = useMediaQuery(theme.breakpoints.up('tablet'));

  const getCareDocImg = isLgScreen
    ? imgLinks['care-document-desktop']
    : imgLinks['care-document-mobile'];

  return (
    <StyledCareDocumentContainer>
      <StyledCareDocumentHeaderContainer>
        <Typography variant="h2">
          <FormattedMessage id="patolo.care.document.title" />
        </Typography>
      </StyledCareDocumentHeaderContainer>

      <StyledCareDocumentBodyContainer>
        <div>
          <Typography variant="p">
            <FormattedMessage id="patolo.care.document.description1" />
          </Typography>

          {isDesktop && (
            <div>
              <Typography variant="p">
                <FormattedMessage id="patolo.care.document.description2" />
              </Typography>

              <DownloadLink
                link={docLink}
                name={intl.formatMessage({ id: 'patolo.care.document.upload.hint' })}
                key="care-doc"
                target="_blank"
                nospace
              >
                <Typography variant="h3">
                  <FormattedMessage id="patolo.care.document.link" />
                </Typography>
              </DownloadLink>
            </div>
          )}
        </div>
        <div>
          <img src={getCareDocImg} alt="Patolo Care Document" />
        </div>
      </StyledCareDocumentBodyContainer>
      {!isDesktop && (
        <div>
          <Typography variant="p">
            <FormattedMessage id="patolo.care.document.description2" />
          </Typography>

          <DownloadLink
            link={docLink}
            name={intl.formatMessage({ id: 'patolo.care.document.upload.hint' })}
            key="care-doc"
            target="_blank"
            nospace
          >
            <Typography variant="h3">
              <FormattedMessage id="patolo.care.document.link" />
            </Typography>
          </DownloadLink>
        </div>
      )}
    </StyledCareDocumentContainer>
  );
};

export default PatoloCareDocument;
